import React from "react";
import {Form, Input, Row, Col, Alert, Divider, Select, Icon, Modal,Button} from "antd";

import "./BankAccountInformationTab.scss";

import CurrencySelector from "components/CurrencySelector";
import {ALL_SUPPORTED} from "domain/Currency";
import CountrySelector from "components/CountrySelector";
import BrdgxCountrySelector from "../selector/BrdgxCountrySelector";
import {getBankCode, getCountryList, getCurrencyCountry} from "../../api/api";
import {displayGenericError} from "../../common/notifications";
import BrdgxBankSelector from "../selector/BrdgxBankSelector";

import { FormattedMessage } from "react-intl";
import withUseIntl from "components/withUseIntl";
import {TARGET_CURRENCY_SUPPORTED} from "../../common/Currency";

const BETA_TARGET_CURRENCY = ["MYR","HKD","CNY","IDR","PHP","VND","THB","USD"]
let index = 0;
const { Option } = Select;

class BankAccountInformationTab extends React.Component {
    state = {
        accountCurrency: {
            value: this.props.currency || null
        },
        transferCurrencies: {
            value: this.props.transferCurrencies || null
        },
        accountNumber: {
            value: ""
        },
        clearingCode: {
            value: ""
        },
        bankBranchName: {
            value: ""
        },
        swiftCode: {
            value: this.props.bankCode
        },
        bankAccountName: {
            value: ""
        }
    };

    handleBankCodeCodeChange(name, value, validationFunction,ev) {
            let bank = this.props.banks.filter(s => s.code === value)
            if (this.props.isPaymentGlobal) {
                if (bank[0].newBank) {
                    this.props.updateBank(bank[0].value, bank[0].swift, bank[0].bankCodeCode,true, this.state.accountNumber.value);
                } else {
                    this.props.updateBank(bank[0].value, bank[0].swift, value, false ,this.state.accountNumber.value);
                    validationFunction(value);
                }
            } else {
                this.props.updateBank(bank[0].value, bank[0].swift, value, false, this.state.accountNumber.value);
                validationFunction(value);
            }
    }
    handleInputChange(event, validationFunction) {
        const target = event.target;
        const inputName = target.name;
        const inputValue = target.value;
        let selectedBeneficiary = this.props.selectedBeneficiary;
        if(selectedBeneficiary) {
            selectedBeneficiary[inputName] = inputValue;
            this.props.changeSelectedBeneficiary(selectedBeneficiary)
        } else {

            this.setState({
                [inputName]: {
                    value: inputValue,
                    ...validationFunction(inputValue)
                }
            }, () => {
                this.props.onCompleted(this.createBankAccountInformation()
                )
            });
        }
    }

    validateAccountCurrency = accountCurrency => {
        const intl = this.props.useIntl;
        if (!accountCurrency) {
            return {
                validateStatus: "error",
                errorMsg: intl.formatMessage({id: "app.message.bankaccountinformationtab.accountcurrency"})
            };
        }
        let selectedBeneficiary = this.props.selectedBeneficiary;
        if(selectedBeneficiary) {
            selectedBeneficiary['accountCurrency'] = accountCurrency;
            this.props.changeSelectedBeneficiary(selectedBeneficiary)
        }else {
            this.setState({
                accountCurrency: {value: accountCurrency}
            }, () => {
                this.props.onCompleted(this.createBankAccountInformation());
            })
        }
        return {
            validateStatus: "success",
            errorMsg: null
        };
    };

    validateTransferCurrencies = transferCurrencies => {
        const intl = this.props.useIntl;
        if (!transferCurrencies) {
            return {
                validateStatus: "error",
                errorMsg: intl.formatMessage({id: "app.message.bankaccountinformationtab.transfer.currency"})
            };
        }
        let selectedBeneficiary = this.props.selectedBeneficiary;
        let transferCurrenciesStr = transferCurrencies.reduce((a,b) => `${a},${b}`);
        if(selectedBeneficiary) {
            selectedBeneficiary['transferCurrencies'] = transferCurrenciesStr;
            this.props.changeSelectedBeneficiary(selectedBeneficiary)
        }else {
            this.setState({
                transferCurrencies: {value: transferCurrenciesStr}
            }, () => {
                this.props.onCompleted(this.createBankAccountInformation());
            })
        }
        return {
            validateStatus: "success",
            errorMsg: null
        };
    };

    validateBankName = bankName => {
        const intl = this.props.useIntl;
        if (!bankName) {
            return {
                validateStatus: "error",
                errorMsg: intl.formatMessage({id: "app.message.bankaccountinformationtab.bankname"})
            };
        }
        return {
            validateStatus: "success",
            errorMsg: null
        };
    };

    validateBankCodeCode = bankCodeCode => {
        const intl = this.props.useIntl;
        if (!bankCodeCode) {
            return {
                validateStatus: "error",
                errorMsg: intl.formatMessage({id: "app.message.bankaccountinformationtab.selectbank"})
            };
        }
        return {
            validateStatus: "success",
            errorMsg: null
        };
    };

    validateSwiftCode = swiftCode => {
        const intl = this.props.useIntl;
        if(this.props.isPaymentGlobal){
            if (!swiftCode) {
                return {
                    validateStatus: "error",
                    errorMsg: intl.formatMessage({id: "app.message.bankaccountinformationtab.swift"})
                };
            } else if (swiftCode.length<8 || swiftCode.length>11) {
                return {
                    validateStatus: "error",
                    errorMsg: intl.formatMessage({id: "app.message.bankaccountinformationtab.swiftlength"})
                };
            }
        }
        return {
            validateStatus: "success",
            errorMsg: null
        };
    }

    validateAccountNumber = accountNumber => {
        const intl = this.props.useIntl;
        if (!accountNumber) {
            return {
                validateStatus: "error",
                errorMsg: intl.formatMessage({id: "app.message.bankaccountinformationtab.accountnumber"})
            };
        }

        if (!this.props.isPaymentGlobal) {
            if (!this.props.bankCodeCode) {
                return {
                    validateStatus: "error",
                    errorMsg: intl.formatMessage({id: "app.message.bankaccountinformationtab.selectbank"})
                };
            }
            let bank = this.props.banks.filter(s => s.code === this.props.bankCodeCode);

            if (bank[0].accDigits == null) {
                return {
                    validateStatus: "success",
                    errorMsg: null
                };
            }
            if(bank[0].code === "BSG0025" && accountNumber.findIndex("855")==0) {
                return {
                    validateStatus: "success",
                    errorMsg: null
                };
            } else {
                let accountDigitsArray = bank[0].accDigits.split(',');
                let isBankAccountValid = false;
                for (let index in accountDigitsArray) {
                    if (accountNumber.length == accountDigitsArray[index]) {
                        isBankAccountValid = true
                    }
                }
                if (!isBankAccountValid) {
                    return {
                        validateStatus: "error",
                        errorMsg: intl.formatMessage({id: "app.message.bankaccountinformationtab.selectbank"}).replace('%length', bank[0].accDigits)
                    };
                    return;
                }
                return {
                    validateStatus: "success",
                    errorMsg: null
                };
            }
        } else {
            return {
                validateStatus: "success",
                errorMsg: null
            };
        }
    };

    validateBankBranchName = bankBranchName => {
        const intl = this.props.useIntl;
        if(this.props.bankCountry === 'C048'){
            if (!bankBranchName) {
                return {
                    validateStatus: "error",
                    errorMsg: intl.formatMessage({id: "app.message.bankaccountinformationtab.bankbranchname"})
                };
            }
        }
        return {
            validateStatus: "success",
            errorMsg: null
        };
    };

    validateClearingCode = clearingCode => {
        const intl = this.props.useIntl;
        let errorMsg = "";
        if(this.props.bankCountry === 'C020') {
            errorMsg = intl.formatMessage({id: "app.message.bankaccountinformationtab.clearingcode"});
        } else if (this.props.bankCountry === 'C004') {
            errorMsg = intl.formatMessage({id: "app.message.bankaccountinformationtab.sortcode"});
        } else if (this.props.bankCountry === 'C005') {
            errorMsg = intl.formatMessage({id: "app.message.bankaccountinformationtab.routingcode"});
        } else {
            errorMsg = intl.formatMessage({id: "app.message.bankaccountinformationtab.clearingcode"});
        }
        if (!clearingCode) {
            return {
                validateStatus: "error",
                errorMsg: errorMsg
            };
        }
        return {
            validateStatus: "success",
            errorMsg: null
        };
    };

    createBankAccountInformation = () => {
        return {
            accountCurrency: this.state.accountCurrency.value,
            transferCurrencies: this.state.transferCurrencies.value,
            country: this.props.bankCountry,
            bankName: this.props.bankName,
            newBank: this.props.newBank,
            bankCode: this.props.bankCode,
            bankCodeCode: this.props.bankCodeCode,
            accountNumber: this.state.accountNumber.value,
            clearingCode: this.state.clearingCode.value,
            bankBranchName: this.state.bankBranchName.value,
            bankAccountName: this.state.bankAccountName.value
        };
    };

    componentDidMount() {
    }

    /*
    buildChargeExtraMsg () {
        const intl = this.props.useIntl;
        if (this.props.isPaymentGlobal) {
            return (
                <>
                <Row gutter={16}>
                    <Alert message={intl.formatMessage({id: "app.message.bankaccountinformationtab.intermediarybanksextrafees"})} type="error" />
                </Row>
                </>
            )
        }
        return null;
    }
    */

    buildClearingCode(){
        const intl = this.props.useIntl;
        let label = "";

        /// UNITED STATES OF AMERICA
        if (this.props.bankCountry === 'C005'){
            label = intl.formatMessage({id: "app.modal.bankaccountinformationtab.routingnumber"});
        // AUSTRALIA
        } else if (this.props.bankCountry === 'C020') {
            label = intl.formatMessage({id: "app.modal.bankaccountinformationtab.bankclearingcode"});

        // C004: UNITED KINGDOM
        }else if (this.props.bankCountry === 'C004'){
            label = intl.formatMessage({id: "app.modal.bankaccountinformationtab.sortcode"});
        }


        return (<>
            {(label) && (
            <Col md={6}>
                <Form.Item
                    required={true}
                    hasFeedback
                    validateStatus={this.state.clearingCode.validateStatus}
                    help={this.state.clearingCode.errorMsg}
                    label={label}
                >
                    <Input
                        name="clearingCode"
                        size={"large"}
                        className="swift-code-input"
                        value={this.props.selectedBeneficiary ? this.props.selectedBeneficiary.clearingCode : this.state.clearingCode.value}
                        onChange={event =>
                            this.handleInputChange(event, this.validateClearingCode)
                        }
                    />
                </Form.Item>
            </Col>
        )}
        </>)
    }

    buildBankname =() => {
        const intl = this.props.useIntl;
        const selectedBeneficiary = this.props.selectedBeneficiary;

        return (<BrdgxBankSelector
            placeholder={intl.formatMessage({id: "app.modal.bankaccountinformationtab.selectbank"})}
            name="bankCodeCode"
            style={{width: '100%'}}
            size={"large"}
            required="true"
            banks={this.props.banks}
            isPaymentGlobal={this.props.isPaymentGlobal}
            value={selectedBeneficiary ?  selectedBeneficiary.bankCodeCode :this.props.bankCodeCode}
            addNewBankName={this.props.addNewBankName}
            onChange={(bankCodeCode,ev) =>
                this.handleBankCodeCodeChange(
                    "bankCodeCode",
                    bankCodeCode,
                    this.validateBankCodeCode,
                    ev
                )
            }
        />);
    }

    render() {
        const intl = this.props.useIntl;
        const selectedBeneficiary = this.props.selectedBeneficiary;
        let isDisableSwiftCode =this.props.isPaymentGlobal ? false : true;
        return (
            <>
            <Form className="bp-form">
                <h3><FormattedMessage id="app.modal.bankaccountinformationtab.bankinformation" /></h3>
                <Row gutter={16}>
                    <Col md={12}>
                        <Form.Item
                            required="true"
                            hasFeedback
                            label={intl.formatMessage({id: "app.modal.bankaccountinformationtab.bank"})}
                            //validateStatus={this.state.bankCodeCode.validateStatus}
                            //help={this.state.bankCodeCode.errorMsg}
                        >

                            {this.buildBankname()}
                        </Form.Item>
                    </Col>
                    <Col md={6}>
                        <Form.Item
                            required="true"
                            hasFeedback
                            validateStatus={this.state.accountNumber.validateStatus}
                            help={this.state.accountNumber.errorMsg}
                            label={intl.formatMessage({id: "app.modal.bankaccountinformationtab.bankaccountnumber"})}
                        >
                            <Input
                                name="accountNumber"
                                size={"large"}
                                value={selectedBeneficiary ? selectedBeneficiary.accountNumber : this.state.accountNumber.value}
                                onChange={event =>
                                    this.handleInputChange(event, this.validateAccountNumber)
                                }
                            />
                        </Form.Item>
                    </Col>
                    <Col md={6}>
                        <Form.Item
                            required="true"
                            hasFeedback
                            label={intl.formatMessage({id: "app.modal.bankaccountinformationtab.swift"})}
                        >
                            <Input
                                name="bankCode"
                                size={"large"}
                                className="swift-code-input"
                                value={selectedBeneficiary ? selectedBeneficiary.bankCode : this.props.bankCode}
                                onChange={event =>  this.props.onChangeSwiftCode (event)}
                                disabled={isDisableSwiftCode}
                            />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col md={12}
                    >
                        <Form.Item
                            required="true"
                            hasFeedback
                            style={{
                                height: "40px",
                                paddingLeft: "0",
                            }}
                            validateStatus={this.state.transferCurrencies.validateStatus}
                            help={this.state.transferCurrencies.errorMsg}
                            label={intl.formatMessage({id: "app.modal.bankaccountinformationtab.transfer.currency"})}
                        >
                            <CurrencySelector
                                disabled={this.props.disabled}
                                mode={"multiple"}
                                className="currency-field-small"
                                defaultValue={this.buildTransferCurrency(selectedBeneficiary)}
                                currencies={TARGET_CURRENCY_SUPPORTED}
                                onCurrencyChanged={(currency,event) =>{
                                    this.validateTransferCurrencies(currency);
                                }}
                            />
                        </Form.Item>
                    </Col>

                    {this.props.bankCountry === 'C048' && (
                        <Col md={6}>
                            <Form.Item
                                hasFeedback
                                validateStatus={this.state.bankBranchName.validateStatus}
                                help={this.state.bankBranchName.errorMsg}
                                label={intl.formatMessage({id: "app.modal.bankaccountinformationtab.bankbranchname"})}
                            >
                                <Input
                                    name="bankBranchName"
                                    size={"large"}
                                    className="swift-code-input"
                                    value={selectedBeneficiary ? selectedBeneficiary.bankBranchName : this.state.bankBranchName.value}
                                    onChange={event =>
                                        this.handleInputChange(event, this.validateBankBranchName)
                                    }
                                />
                            </Form.Item>
                        </Col>
                    )}
                    {this.buildClearingCode()}

                    {this.buildBankAccountName(selectedBeneficiary, this.props.currentCustomer)}
                </Row>
                <Row gutter={16}>
                    <Col md={12}>
                        <FormattedMessage id="app.modal.bankaccountinformationtab.mandatoryfields" />
                    </Col>
                </Row>
                {/*this.buildChargeExtraMsg()*/}
            </Form>
            </>
        );
    }

    buildTransferCurrency(selectedBeneficiary) {
        if(selectedBeneficiary && selectedBeneficiary.transferCurrencies) {
                if (!Array.isArray(selectedBeneficiary.transferCurrencies)) {
                    return selectedBeneficiary.transferCurrencies.split(",");
                } else {
                    return selectedBeneficiary.transferCurrencies;
                }
        }
            return [];

    }

    buildBankAccountName(selectedBeneficiary, currentCustomer) {
        const intl = this.props.useIntl;
        let bankAccountName = "";
        let isPartner = currentCustomer.customerTierName && currentCustomer.customerTierName.includes('PARTNER');
        if (selectedBeneficiary) {
            if(selectedBeneficiary.bankAccountName) {
                bankAccountName = selectedBeneficiary.bankAccountName;
            } else {
                if (selectedBeneficiary.beneficiaryType == "INDIVIDUAL") {
                    bankAccountName = selectedBeneficiary.firstName + " " + selectedBeneficiary.lastName;
                } else {
                    bankAccountName = selectedBeneficiary.businessName;
                }
            }
        }

        return (
        <>
            <Col md={6}>
                <Form.Item
                    hasFeedback
                    label={intl.formatMessage({id: "app.modal.bankaccountinformationtab.bank.account.name"})}
                >
                    <Input
                        name="bankAccountName"
                        disabled={true}
                        size={"large"}
                        //className="swift-code-input"
                        value={this.state.bankAccountName.value ? this.state.bankAccountName.value : bankAccountName }
                        defaultValue={bankAccountName}
                    />
                </Form.Item>
            </Col>
            <Col md={6}>
                {isPartner && (
                    <Form.Item
                    hasFeedback
                    label={intl.formatMessage({id: "app.modal.bankaccountinformationtab.use.partner.bank.account.name"})}
                    >
                    <Input name="usePartnerBankAccountName" type="checkbox"
                        defaultChecked={bankAccountName === currentCustomer.name}
                        onChange={e => {
                            if (e.target.checked) {
                                if (selectedBeneficiary) {
                                    selectedBeneficiary.bankAccountName = currentCustomer.corporateAccountDetails ? currentCustomer.corporateAccountDetails.nameOfBusiness :'';
                                    this.props.changeSelectedBeneficiary(selectedBeneficiary);
                                    this.setState({
                                        bankAccountName: {value: selectedBeneficiary.bankAccountName}
                                    });
                                } else {
                                    this.setState({
                                        bankAccountName: {value: currentCustomer.corporateAccountDetails ? currentCustomer.corporateAccountDetails.nameOfBusiness : ''}
                                    }, () => {
                                        this.props.onCompleted(this.createBankAccountInformation());
                                    })
                                }
                                
                            } else {
                                if (selectedBeneficiary) {
                                    if (selectedBeneficiary.beneficiaryType == "INDIVIDUAL") {
                                        bankAccountName = selectedBeneficiary.firstName + " " + selectedBeneficiary.lastName;
                                    } else {
                                        bankAccountName = selectedBeneficiary.businessName;
                                    }
                                    selectedBeneficiary.bankAccountName = bankAccountName;
                                    this.props.changeSelectedBeneficiary(selectedBeneficiary);
                                    this.setState({
                                        bankAccountName: {value: selectedBeneficiary.bankAccountName}
                                    });
                                } else {
                                    this.setState({
                                        bankAccountName: {value: ""}
                                    }, () => {
                                        this.props.onCompleted(this.createBankAccountInformation());
                                    })
                                }
                            }
                        }}
                     />
                    </Form.Item>
                )}
            </Col>
        </>
        );
    }
}

export default withUseIntl(BankAccountInformationTab);